import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';
import { AppState } from 'services/types';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Actions
import { updateQueryString } from 'services/router/actions';

import pluralize from 'utils/pluralize';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import SprayEventTypeCropGate from 'components/SprayEventTypeCropGate';
import SprayEventTypeWeedGate from 'components/SprayEventTypeWeedGate';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

// Services
import { SprayEventUuid } from 'services/sprayEvents/types';
import { requestCompleteSprayEvents } from 'services/sprayEvents/actions';

import { makeSelectSelectedIncompleteSprayEventsUuids } from '../SprayEventsVirtualizedTable/selectors';

import CompleteCropSprayEventForm from './components/CompleteCropSprayEventForm';
import CompleteWeedSprayEventConfirmation from './components/CompleteWeedSprayEventConfirmation';
import { COMPLETE_SPRAY_EVENT_MODAL } from './constants';

interface ConnectedProps {
    completeSprayEventModal: boolean;
    uuids: SprayEventUuid[];
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
    requestCompleteSprayEvents: typeof requestCompleteSprayEvents;
}

interface OwnProps {
    fullscreen: boolean;
}

export type Props = ConnectedProps & DispatchProps & OwnProps;

export class CompleteSprayEventModalComponent extends React.PureComponent<Props> {
    get open(): boolean {
        const { completeSprayEventModal, uuids, ...props } = this.props;

        if (completeSprayEventModal && !uuids.length) {
            props.updateQueryString({
                [COMPLETE_SPRAY_EVENT_MODAL]: undefined
            });
        }

        return !!completeSprayEventModal && !!uuids && !!uuids.length;
    }

    handleClose = (): void => {
        this.props.updateQueryString({
            [COMPLETE_SPRAY_EVENT_MODAL]: undefined
        });
    };

    render(): React.ReactElement {
        const { uuids, fullscreen } = this.props;

        const size = fullscreen ? 'fullscreen' : 'tiny';

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size={size}
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace={COMPLETE_SPRAY_EVENT_MODAL}
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>
                            Complete Spray{' '}
                            {pluralize(uuids.length, 'Event', 'Events')}
                        </Modal.Header>
                        <Modal.Content>
                            <SprayEventTypeCropGate>
                                <CompleteCropSprayEventForm />
                            </SprayEventTypeCropGate>
                            <SprayEventTypeWeedGate>
                                <CompleteWeedSprayEventConfirmation />
                            </SprayEventTypeWeedGate>
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    completeSprayEventModal: makeSelectQueryStringValue(
        COMPLETE_SPRAY_EVENT_MODAL
    ),
    uuids: makeSelectSelectedIncompleteSprayEventsUuids()
});

export default connect(mapStateToProps, {
    updateQueryString,
    requestCompleteSprayEvents
})(CompleteSprayEventModalComponent);
